// Pega o basePath das configurações do webpack config/xxx.env
let basePath = process.env.API_URL
let baseAPIGroup = 'api/'
let APIVersion = 'v1/'
let appVersion = process.env.APP_VERSION || null

export default {
  basePath: basePath,
  baseAPIGroup: baseAPIGroup,
  APIVersion: APIVersion,
  fullAPIPath: basePath + baseAPIGroup + APIVersion,
  appVersion: appVersion
}



// WEBPACK FOOTER //
// ./src/config.js